import _Tooltip from "@material-ui/core/esm/Tooltip";
import _Fab from "@material-ui/core/esm/Fab";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import VerticalAlignCenter from '@material-ui/icons/VerticalAlignCenter';
import { CSSTransition } from 'react-transition-group';
import { makeStyles } from '@material-ui/core/styles';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import appearAnimationClasses from '../design-note/appear.anim.scss';
import classes from '../../tools-panel.scss';
import { PRIMARY_BUTTON } from '../../../../../../../../constants/styles';
import centerLogoClasses from './center-logo.scss';
const BUTTONS = {
  CENTER: 'CENTER',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
};
const useStyles = makeStyles(() => ({
  button: _objectSpread({}, PRIMARY_BUTTON, {
    width: '27px',
    height: '27px',
    minHeight: '27px',
    fontSize: '12px',
    padding: 0,
    margin: '5px 5px 0 0',
    borderRadius: '50px',
    border: '1px solid #eaeaea'
  }),
  whiteButton: {
    backgroundColor: '#fff',
    fontSize: '15px'
  }
}));
function CenterLogo({
  isDisabled,
  isOpened,
  onChangeOpenedState,
  hasAdvancedPositioning,
  onClickAlignCenter,
  onClickAlignLeft,
  onClickAlignRight
}) {
  // @ts-ignore
  const myStyles = useStyles();
  const onToolbarClick = () => {
    if (isDisabled) {
      return null;
    }
    if (hasAdvancedPositioning) {
      onChangeOpenedState();
    } else {
      onClickAlignCenter();
    }
  };
  const [activeButton, changeActiveButton] = useState(null);
  useEffect(() => {
    if (!isOpened) {
      changeActiveButton(null);
    }
  }, [isOpened]);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItem, classes.overflowVisible)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItemMainColumn, {
      [classes.toolbarItemDisabled]: isDisabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onToolbarClick,
    className: classes.toolbarItemHead,
    tabIndex: isDisabled ? -1 : 0,
    "aria-label": "Align Logo",
    onKeyDown: e => handleOnEnterPressed(e, onToolbarClick)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.toolbarItemIcon, classes.rotate90)
  }, /*#__PURE__*/React.createElement(VerticalAlignCenter, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarItemHeadText,
    "data-button": "AlignLogo"
  }, "Align Logo"))), hasAdvancedPositioning && /*#__PURE__*/React.createElement(CSSTransition, {
    in: isOpened,
    timeout: 250,
    classNames: appearAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: centerLogoClasses.rightDropdown
  }, /*#__PURE__*/React.createElement(_Tooltip, {
    title: "Center logo",
    placement: "top-start"
  }, /*#__PURE__*/React.createElement(_Fab, {
    component: "div",
    className: classnames(myStyles.button, {
      [myStyles.whiteButton]: activeButton !== BUTTONS.CENTER
    }),
    color: "default",
    onClick: () => {
      changeActiveButton(BUTTONS.CENTER);
      onClickAlignCenter();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: centerLogoClasses.centerBtn
  }))), /*#__PURE__*/React.createElement(_Tooltip, {
    title: "Left chest logo",
    placement: "top-start"
  }, /*#__PURE__*/React.createElement(_Fab, {
    component: "div",
    className: classnames(myStyles.button, {
      [myStyles.whiteButton]: activeButton !== BUTTONS.LEFT
    }),
    color: "default",
    onClick: () => {
      changeActiveButton(BUTTONS.LEFT);
      onClickAlignLeft();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: centerLogoClasses.leftChtBtn
  }))), /*#__PURE__*/React.createElement(_Tooltip, {
    title: "Right chest logo",
    placement: "top-start"
  }, /*#__PURE__*/React.createElement(_Fab, {
    component: "div",
    className: classnames(myStyles.button, {
      [myStyles.whiteButton]: activeButton !== BUTTONS.RIGHT
    }),
    color: "default",
    onClick: () => {
      changeActiveButton(BUTTONS.RIGHT);
      onClickAlignRight();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: centerLogoClasses.rightChtBtn
  }))))));
}
export default CenterLogo;